import React from "react";
import IcecastMetadataPlayer from "icecast-metadata-player";
import ControlButton from "../../../components/ControlButton";

interface Props {
  type?: string;
  player: IcecastMetadataPlayer;
}

const ControlPlayer: React.FC<Props> = ({ player }) => {
  return (
    <>
      <div className="cursor-pointer">
        <ControlButton player={player} />
      </div>
    </>
  );
};

export default ControlPlayer;
